var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { friendlyDocType } from "./doc-labels";
let ChartNavigator = class ChartNavigator extends LitElement {
    constructor() {
        super(...arguments);
        this.documents = [];
        // The currently-open document, passed down from the case view; defaults to the first.
        this.selectedId = null;
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; padding: 10px 8px; background: var(--color-slate-100); }
    h4 { margin: 14px 6px 5px; font-size: var(--fs-label); text-transform: uppercase;
         color: var(--color-slate-500); letter-spacing: .06em; font-weight: 700; }
    h4:first-child { margin-top: 4px; }
    ul { list-style: none; padding: 0; margin: 0; }
    button { width: 100%; text-align: left; background: transparent; border: 0;
             padding: 7px 9px; font-size: var(--fs-ui); border-radius: 6px; line-height: 1.3;
             color: var(--color-slate-700); cursor: pointer; }
    button:hover { background: var(--color-slate-200); }
    /* Keep the selected record highlighted after it is clicked. */
    button.selected, button.selected:hover {
      background: var(--color-blue-50, #EFF6FF); color: var(--color-blue-700, #1D4ED8);
      font-weight: 600; box-shadow: inset 3px 0 0 var(--color-blue-600, #2563EB);
    }
  `; }
    grouped() {
        const out = {};
        for (const d of this.documents) {
            (out[d.category] ??= []).push(d);
        }
        return out;
    }
    emitFocus(docId) {
        this.dispatchEvent(new CustomEvent("doc-focus", {
            detail: { docId }, bubbles: true, composed: true,
        }));
    }
    render() {
        const g = this.grouped();
        const sel = this.selectedId ?? this.documents[0]?.id ?? null;
        return html `
      <nav aria-label="Chart sections">
        ${Object.entries(g).map(([cat, docs]) => html `
          <h4>${cat}</h4>
          <ul>
            ${docs.map((d) => html `
              <li>
                <button data-doc-id=${d.id} class=${d.id === sel ? "selected" : ""}
                        aria-current=${d.id === sel ? "true" : "false"}
                        @click=${() => this.emitFocus(d.id)}>${friendlyDocType(d.type)}</button>
              </li>
            `)}
          </ul>
        `)}
      </nav>
    `;
    }
};
__decorate([
    property({ attribute: false })
], ChartNavigator.prototype, "documents", void 0);
__decorate([
    property({ attribute: false })
], ChartNavigator.prototype, "selectedId", void 0);
ChartNavigator = __decorate([
    customElement("chart-navigator")
], ChartNavigator);
export { ChartNavigator };
